export enum ReminderType {
  GLOBAL = 'GLOBAL',
  PRIVATE = 'PRIVATE',
}
